import moment from "moment";



const calculeDifference = (startDate, endDate, days) => {
        let startMoment = moment(startDate).startOf("day");
        let endMoment = moment(endDate).endOf("day");
        let diffInDays = endMoment.diff(startMoment, 'days');
        if (diffInDays > days) {
                return true;
        }
        else {
                return false
        }

}

export default {
        calculeDifference
}
